export default function (req, res, next) {
  if(req.url.match(/index\.html$/)) {
    req.url = req.url.replace(/index\.html$/, '')
  }

  next()
}